import { useMutation } from "@tanstack/react-query";
import {
  type JobTaskSkipSchema,
  mvpApiSkipJobTask,
} from "@augmodo/lebron-browser-client";

export function useSkipJobTask(jobId: string, taskId: string) {
  return useMutation({
    mutationFn: async (
      payload: JobTaskSkipSchema,
    ): Promise<JobTaskSkipSchema> => {
      const response = await mvpApiSkipJobTask({
        path: {
          job_id: jobId,
          task_id: taskId,
        },
        body: payload,
      });

      if (response.error) {
        throw new Error(`Failed to fetch image gallery: ${response.error}`);
      }

      return response.data as JobTaskSkipSchema;
    },
    onSuccess: (data) => {
      return data;
    },
    onError: (error) => {
      console.error("Skip job task failed:", error);
    },
  });
}
